// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__FTRea","cross":"Popup_cross__RKax0","shake":"Popup_shake__Zru4a","thanking":"Popup_thanking__DjEbD","innerbox":"Popup_innerbox__cN7LC"};